/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_PhysioInputs */

const en_for_whom_physio = /** @type {(inputs: For_Whom_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physio`)
};

const pl_for_whom_physio = /** @type {(inputs: For_Whom_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapeuta`)
};

/**
* | output |
* | --- |
* | "Physio" |
*
* @param {For_Whom_PhysioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_physio = /** @type {((inputs?: For_Whom_PhysioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_PhysioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_physio(inputs)
	return en_for_whom_physio(inputs)
});